import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function MobileIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 7 1 C 5.895 1 5 1.895 5 3 L 5 21 C 5 22.105 5.895 23 7 23 L 17 23 C 18.105 23 19 22.105 19 21 L 19 3 C 19 1.895 18.105 1 17 1 L 7 1 z M 7 3 L 17 3 L 17 5 L 7 5 L 7 3 z M 7 7 L 17 7 L 17 16 L 7 16 L 7 7 z M 7 18 L 17 18 L 17 21 L 7 21 L 7 18 z M 10 19 L 10 20 L 14 20 L 14 19 L 10 19 z" />
        </SvgIcon>
    );
}
